import { render, staticRenderFns } from "./userContribute.vue?vue&type=template&id=085c28cd&scoped=true&"
import script from "./userContribute.vue?vue&type=script&lang=js&"
export * from "./userContribute.vue?vue&type=script&lang=js&"
import style0 from "./userContribute.vue?vue&type=style&index=0&id=085c28cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c28cd",
  null
  
)

export default component.exports